import templateUrl from 'emun.customer/customer-quick-view.htm'
import ServiceBus from 'servicestack/service-bus'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import activityConfig from 'emun.activity/activity.config'
class controller {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.ytdSales = {
            total: 0,
            count: 0
		};
		$ctrl.activityConfig = activityConfig;
    }
    $onInit(){
        const $ctrl = this;
        const id = $ctrl.customer && $ctrl.customer.id || $ctrl.customerId;
        $ctrl.bus = new ServiceBus();
        $ctrl.bus.read(`QueryRetailers/${id}.json?Take=1`).then(res=> {
            let customer = $ctrl.customer = Object.assign({},$ctrl.customer, res.data.results[0]);
            $ctrl.customer.location = customer.address + ", " + customer.city + ", " + customer.state + " " + customer.zip;
           
            $ctrl.bus.read('QueryOrdersJoin.json?_GroupBy=Staus&StatusIn=Open&RetailerId=' + $ctrl.customer.id).then(res=> {
                $ctrl.totalsByStatus = res.data;
            });
            $ctrl.ordersQuery = new AutoQuery({
                url: 'QueryOrdersJoin.json?orderBy=-OrderedOn&retailerId=' + $ctrl.customer.id,
                take: 10,
                autoLoad: true
            });
            $ctrl.ytdSalesQuery = new AutoQuery({
                url: 'QueryOrderTotals.json?dateRange=YTD&customerId=' + $ctrl.customer.id,
                autoLoad: true,
                onLoaded: args => {$ctrl.ytdSales.total = Math.round(args.first.total); $ctrl.ytdSales.count = args.first.count;}
            });
        });
    }
    openMap() {
        const $ctrl = this;
        window.open("https://www.google.com/maps/place/" + $ctrl.customer.location);
    }
}

let component = {
    bindings: {
        customerId: '@',
        customer: '<?'
    },
    controller,
    templateUrl: ($element, $attrs) =>  $attrs.templateUrl || templateUrl
}

export default component